import React, { useEffect, useState } from "react";
import { useAdminAuth } from "@/admin/AdminAuthContext";
import { Users, Download, Loader2 } from "lucide-react";

const formatDate = (iso) => {
  try {
    return new Date(iso).toLocaleString("fr-FR", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export default function AdminSubscribers() {
  const { authFetch } = useAdminAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authFetch("get", "/admin/subscribers")
      .then((res) => setItems(res.data.items))
      .finally(() => setLoading(false));
  }, [authFetch]);

  const exportCSV = () => {
    const rows = [["email", "source", "created_at"], ...items.map((s) => [s.email, s.source, s.created_at])];
    const csv = rows.map((r) => r.map((v) => `"${String(v ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `phenix-abonnes-${new Date().toISOString().slice(0, 10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div data-testid="admin-subscribers-root">
      <div className="flex items-end justify-between flex-wrap gap-4 mb-10">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <Users size={16} strokeWidth={1.5} className="text-[#b08d57]" />
            <span className="text-[10px] tracking-[0.32em] uppercase text-[#b08d57]">
              Abonnés newsletter
            </span>
          </div>
          <h1 className="font-serif text-4xl md:text-5xl">
            {items.length} abonné{items.length > 1 ? "s" : ""}
          </h1>
        </div>
        <button
          onClick={exportCSV}
          disabled={items.length === 0}
          data-testid="admin-subscribers-export"
          className="inline-flex items-center gap-2 border border-[#b08d57]/60 text-[#f0b74e] px-5 py-3 text-xs tracking-[0.24em] uppercase hover:bg-[#b08d57] hover:text-[#0a192f] transition-colors disabled:opacity-50"
        >
          <Download size={14} strokeWidth={1.5} />
          Exporter CSV
        </button>
      </div>

      {loading ? (
        <div className="text-[#efeade]/50 flex items-center gap-2">
          <Loader2 className="animate-spin" size={16} /> Chargement…
        </div>
      ) : (
        <div className="border border-[#efeade]/10 overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="bg-white/5 text-[#efeade]/60 text-[10px] tracking-[0.24em] uppercase">
                <th className="text-left px-5 py-4">E-mail</th>
                <th className="text-left px-5 py-4">Source</th>
                <th className="text-left px-5 py-4">Inscrit le</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#efeade]/5">
              {items.map((s) => (
                <tr key={s.id} data-testid={`admin-subscriber-${s.email}`}>
                  <td className="px-5 py-4 text-[#efeade]">{s.email}</td>
                  <td className="px-5 py-4 text-[#efeade]/60">{s.source}</td>
                  <td className="px-5 py-4 text-[#efeade]/60">{formatDate(s.created_at)}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr>
                  <td colSpan={3} className="px-5 py-10 text-center text-[#efeade]/50">
                    Aucun abonné pour le moment.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
